export const authorizationErrorCodes = {
    codeRequired: 'code_required',
    loginRequired: 'login_required',
    interactionRequired: 'interaction_required',
    accountSelectionRequired: 'account_selection_required',
    consentRequired: 'consent_required'
};
export const promptRedirectErrors = [
    authorizationErrorCodes.loginRequired,
    authorizationErrorCodes.interactionRequired,
    authorizationErrorCodes.accountSelectionRequired,
    authorizationErrorCodes.consentRequired
];
export const authorizePromptType = {
    login: 'login',
    none: 'none'
};
export const tokenHintType = {
    accessToken: 'access_token',
    refreshToken: 'refresh_token'
};
export const grantType = {
    refreshToken: 'refresh_token',
    authorizationCode: 'authorization_code',
    password: 'password'
};
export const workerMessageType = {
    revokeToken: 'REVOKE_TOKEN',
    getToken: 'GET_TOKEN',
    getIsRefreshing: 'GET_IS_REFRESHING'
};
export const errorReason = {
    invalidRefresh: 'invalidRefresh',
    brokenSession: 'brokenSession',
    generic: 'generic'
};
export const TOKEN_LOCK_KEY = 'TOKEN_LOCK';
export const subscribeEvents = {
    token: 'token'
};
